// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"79626b82","465":"f0860ffc","488":"a819c493","584":"771cb49e","721":"106f5d33","738":"cb2403b9","900":"c82c57fa","962":"65205d65"}[chunkId] + ".chunk.js";
};